







































































































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import ExamComponent from '../organisms/Exam.vue'
import ExamCategory from '../atoms_molecules/ExamCategory.vue'
import SubPage from '../atoms_molecules/SubPage.vue'
import { LETTER_FORMAT } from '../../utils/constants'
import ExamModel from '../../models/exam'
import { subMonths } from 'date-fns'
import { examMyState } from '../../stores/exam_my'
import { userState } from '../../stores/user'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import ExamDashboardChart from '../atoms_molecules/ExamDashboardChart.vue'
import { checkMobile } from '../../utils/utils'
import { PageModeType } from '../../types'
import { makeChannel } from '../../../../action_cable/cable'
const NUMBER_PER_PAGE = 10

@Component({
  components: {
    ExamComponent,
    ExamCategory,
    ExamDashboardChart,
    SubPage,
  }
})
export default class ExamMyList extends Vue {
  isMobile: boolean = false
  mobile = checkMobile()
  drawerRight = !this.mobile
  LETTER_FORMAT = LETTER_FORMAT
  drawer: boolean = false
  endDate: string = new Date().toString()
  startDate: string = subMonths(new Date(), 1).toString()
  pageLoading: boolean = true
  search: string = ""
  title: string = "すべてのテスト"
  show: boolean = true
  
  breadcrumbs = [
    {
      text: 'クラスルーム',
      disabled: false,
      exact: true,
      to: '/classroom/'
    },
    {
      text: 'マイテスト',
      disabled: false,
      exact: true,
      to: '/classroom/my-exams'
    }
  ]

  updateComponent(){    
    var self = this;
    self.show = false;
    self.search = " "
     
    Vue.nextTick(function (){
      self.search = ""
      self.show = true;
    })
  }

  get allExams() {
    return examMyState.list
  }

  get user() {
    return userState.user
  }

  get exams() {
    // 再テストじゃないExamだけ使います
    const parentExams = this.allExams.filter((exam) => !exam.parentId)

    // 最近にテストしたExamをソートします
    const parentExamPayloads = parentExams
      .map((exam) => {
        return {
          exam,
          lastTestAt: this.getLastTestAt(exam)
        }
      })
      .sort((a, b) => (a.lastTestAt > b.lastTestAt ? -1 : 1))

    return parentExamPayloads.map((payload) => payload.exam)
  }

  getLastTestAt(parentExam: ExamModel) {
    let userExams = parentExam.userExams
    this.allExams
      .filter((exam) => exam.parentId == parentExam.id)
      .forEach((exam) => {
        userExams = [...userExams, ...exam.userExams]
      })
    return userExams.reduce(
      (lastTestAt: Date, userExam) => (lastTestAt && lastTestAt > userExam.createdAt ? lastTestAt : userExam.createdAt),
      userExams[0].createdAt
    )
  }

  get categories() {
    return examMyState.categories
  }

  get isShowGraph() {
    return this.user!.isShowGraph
  }
  get hasAnyExam() {
    return examMyState.hasAnyExam
  }

  get searchingExam() {
    return examMyState.searchingExam
  }

  get isLoading() {
    return examMyState.isLoading || userState.isLoading
  }

  get category() {
    return examMyState.category
  }

  page = 1
  pagingLoading = false
  isEndList = false
  get currentExams(): ExamModel[] {
    var result = this.exams

    const listId = this.$route.query['list_id']
    if (listId) {
      const category = this.findCategoryById(Number(listId))
      result = category ? category.getExams(this.exams) : []
    }

    var target = result.slice(0, this.page * NUMBER_PER_PAGE)

    if (target.length == result.length) {
      this.isEndList = true
    }

    return result
  }

  get schoolSetting() {
    return headerState.schoolSetting
  }

  async resetSearchValue() {
    if (this.search) {
      this.search = ""
      await examMyState.getMyExams(this.startDate, this.endDate, "")
      this.resetPaging()
    }
  }

  @Watch('search')
  async getExamFromSearch() {
    if (this.search) {
      this.title = "テスト検索"
      console.log(this.search);
      await examMyState.searchMyExam(this.search)
    }
  }

  async created() {
    await this.initChannel()
    await userState.getUser()
    await examMyState.getMyCategories()
    footerState.setFooterDefault()
    this.pageLoading = false
    this.onChangeQueryRoute()
    headerState.setTitle('テスト一覧')
    window.addEventListener('scroll', this.handleScroll)

  }

  async initChannel() {
    const chanel = makeChannel(
      'NotificationChannel',
      (e) => {
        if (e.content == 'marked_exam') {
          this.updateComponent()
        }
      },
      () => {
        chanel.send({
          action: 'follow'
        })
      }
    )
  }

  pageMode: PageModeType = 'main_page'
  subPageExam: ExamModel | null = null
  onSwitchMode(pageMode: PageModeType) {
    this.pageMode = pageMode
    this.$router.push({
      query: {
        ...this.$route.query ?? {},
        exam_id: undefined
      }
    })
  }

  onShowHistories(exam: ExamModel) {
    this.pageMode = 'sub_page'
    this.subPageExam = exam
    this.$router.push({
      query: {
        ...this.$route.query ?? {},
        exam_id: exam.id.toString()
      }
    })
  }

  handleScroll(e) {
    if (this.$el.clientHeight + this.$el.scrollTop >= this.$el.scrollHeight && !this.pagingLoading && !this.isEndList) {

      // Gia lap paging in frontend
      this.pagingLoading = true
      setTimeout(() => {
        this.pagingLoading = false
        this.page += 1
      }, 2000);
    }
  }

  resetPaging() {
    this.page = 1
    this.isEndList = false
  }

  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
  }

  onResize() {
    this.isMobile = window.innerWidth < 600
  }

  @Watch('$route')
  async onChangeQueryRoute() {
    let categoryId = this.$route.query['list_id']
    let startDate = this.$route.query['start_date']
    let endDate = this.$route.query['end_date']
    if (categoryId == undefined && startDate == undefined && endDate == undefined) {
      if (this.user!.lastExamAt) {
        endDate = this.user!.lastExamAt
        startDate = subMonths(new Date(endDate), 1).toString()
      } else {
        endDate = new Date().toString()
        startDate = subMonths(new Date(), 1).toString()
      }
    }
    await this.getExamsByQuery(startDate, endDate, categoryId)
    this.startDate = startDate as string
    this.endDate = endDate as string
    if (categoryId && this.findCategoryById(Number(categoryId)) != this.category) {
      if (this.exams.length > 0) {
        this.endDate = this.exams[0].userExam.createdAt.toString()
        this.startDate = this.exams[this.exams.length - 1].userExams.slice(-1)[0].createdAt.toString()
      }
    }
    if (categoryId) {
      this.title = this.findCategoryById(Number(categoryId)).name
    } else {
      this.title = 'すべてのテスト'
    }

    if (this.$route.query['exam_id']) {
      const exam = this.allExams.find(item => item.id.toString() === this.$route.query['exam_id'])
      if (exam) {
        this.onShowHistories(exam)
      }
    }
  }

  async getExamsByQuery(startDate, endDate, categoryId) {
    categoryId = categoryId == undefined ? '' : categoryId
    startDate = startDate == undefined ? '' : startDate
    endDate = endDate == undefined ? '' : endDate
    await examMyState.getMyExams(startDate, endDate, categoryId)
    this.resetPaging()
  }

  findCategoryById(id: number) {
    for (let index = 0; index < this.categories.length; index++) {
      const category = this.categories[index].find(id)
      if (category) {
        return category
      }
    }
    return null
  }

  async resetCategory() {
    this.$router.replace({ query: {} })
  }

  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize)
    }
  }
}
